var map = {
	"./1-min.png": 2492,
	"./2-min.png": 6463,
	"./3-min.png": 3998,
	"./4-min.png": 3577,
	"./5-min.png": 3200,
	"./6-min.png": 7875,
	"./7-min.png": 4418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8248;